import React, { useState } from "react";
import logo from '../../assets/logo.png'
import { useParams } from "react-router-dom";
import '../../App.css'
import axios from "axios";

const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const { id } = useParams()

    const apiUrl = "https://api.ipinplus.com/user/reset-password";

    const passwordReset = async (e) => {
        e.preventDefault();
        if (!id) {
            alert("Reset token is missing from the URL.");
            return;
        }

        if (!newPassword || !confirmPassword) {
            alert("Please fill in both password fields.");
            return;
        }
        if (newPassword !== confirmPassword) {
            alert("Passwords do not match. Please try again.");
            return;
        }

        const payload = {
            resetLink: id,
            resetPassword: newPassword,
        };

        try {
            const response = await axios.put(apiUrl, payload);
            const { success, message } = response.data

            if (!success) {
                throw new Error(`Error: ${response.status} - ${message}`);
            }


            console.log("Password reset successful:", message);
            setSuccessMessage("Your password has been updated. You can now log in with your new password.");
        } catch (error) {
            console.error("Error during password reset:", error);
            alert("Failed to reset password. Please try again.");
        }
    };

    if (successMessage) {
        return (
            <div className="container">
                <div id="form-container">
                    <h2>Password Reset Successfully</h2>
                    <p>{successMessage}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="logo">
                <img width="100%" src={logo} alt="Logo" />
            </div>
            <form onSubmit={(e) => passwordReset(e)} id="form-container">
                <h2>Reset your password</h2>
                <label htmlFor="new-password">New Password</label>
                <input
                    type="password"
                    id="new-password"
                    placeholder="New Password"
                    required
                    minLength="6"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />

                <label htmlFor="confirm-password">Confirm Password</label>
                <input
                    type="password"
                    id="confirm-password"
                    placeholder="Confirm Password"
                    required
                    minLength="6"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />

                <button type="submit" className="btn">
                    Reset My Password
                </button>
            </form>
        </div>
    );
};

export default ResetPassword;
